<template>
   <div class="outer-div">
      <textarea v-model="value" @input="$emit('input', value); getScroll()" ref="textarea" class="textarea"  @focus="handler" @blur="on_blur"
      ></textarea>
      <span class="placeholder whitespace-no-wrap" :class="{ 'focus': in_focus}">{{placeholder}}</span>
    </div>
</template>
<script>
export default {
  name: 'mozgoArea',
  props: ['placeholder', 'outerValue'],
  data() {
    return {
      scrollHeight: '',
      value: '',
      in_focus: false,
    };
  },
  mounted() {
    this.getScroll();
    this.value = this.outerValue;
    if (this.value) {
      this.in_focus = true;
    }
  },
  methods: {
    getScroll() {
      this.$refs.textarea.style.height = `${this.$refs.textarea.scrollHeight}px`;
    },
    handler() {
      this.in_focus = true;
    },
    on_blur() {
      this.$emit('blur');
      if (this.value) return;
      this.in_focus = false;
    },
  },
};
</script>
<style scoped>
.textarea {
    @apply relative w-full  border-brand-light outline-none  font-bold font-bold text-sm  text-main-text;
  border-bottom: 1px solid #979797;
  height: 20px;
  overflow: hidden;
  resize: none;
}
.outer-div {
 @apply pt-5 px-1 relative
}
.placeholder {
  @apply absolute pointer-events-none font-bold px-1 text-sm;
  transition: all 0.3s;
  top: 20px;
  color: #979797;
  left: 0;
}
.placeholder.focus {
  @apply text-additional-text text-mxs;
  top: 5px;
}
.textarea:focus {
  border-bottom: 1px solid #dd006f;
}
</style>
